import { h } from "preact";
import { Modal, Button, Typography } from "antd";
import {Fragment} from "react";

export const VlinkModal = ({
                               setIsModalOpen,
                               isModalOpen,
                               vlink,
                               setVlink,
                               mode
                           }) => {
    const onTooltipClick = (value) => navigator.clipboard.writeText(value);

    return (
        <Modal
            visible={isModalOpen}
            onCancel={() => {
                setIsModalOpen(false);
                if (setVlink) setVlink("");
            }}
            footer={null}
            width={700}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#3C8DFC",
                    flexDirection: "column",
                }}
            >
                <Typography.Text>
                    <h2>Great!</h2>
                </Typography.Text>

                {mode === "flow" ? (
                    <>
                        <Typography.Text>
                            <p>Your flow was successfully created!</p>
                        </Typography.Text>
                        <Typography.Text>
                            <p>Copy the link below to proceed.</p>
                        </Typography.Text>
                        <Button style={{ marginLeft: "10px" }}>
                            <Typography.Text
                                onClick={() => onTooltipClick(vlink)}
                                copyable
                                className="settings-api-tab-key"
                            >
                                {vlink}
                            </Typography.Text>
                        </Button>
                    </>
                ) : (
                    <>
                        <Typography.Text>
                            <p>Your template was created successfully!</p>
                        </Typography.Text>
                        <Typography.Text>
                            <p>You can now use this template to create flows or share it with your team.</p>
                        </Typography.Text>
                    </>
                )}
            </div>
        </Modal>
    );
};